require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wob-boardroom-simulation.json") })
        }
      }, "path---wob-boardroom-simulation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wob-boardroom-simulation!./.cache/json/wob-boardroom-simulation.json
// module id = 1282
// module chunks = 231608221292675